import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import { useId } from '../../hooks';
const Context = createContext({
    id: '',
    isOpen: false,
    onChange: () => { },
    position: 'top',
    setIsOpen: () => { }
});
function Provider({ id: customId, isOpen: defaultIsOpen = false, children, onChange = () => { }, position = 'top', ...rest }) {
    const id = useId(customId);
    const [isOpen, setIsOpen] = useState(defaultIsOpen);
    const value = useMemo(() => ({
        id,
        isOpen,
        setIsOpen,
        onChange,
        position
    }), [id, isOpen, onChange, position]);
    return (_jsx(Context.Provider, { value: value, ...rest, children: children }));
}
export const useTooltipContext = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useTooltipContext must be used within a TooltipProvider');
    }
    return context;
};
export { Context, Provider };
//# sourceMappingURL=Context.js.map